import { createSelector } from 'reselect'
const getCurrentLibraries = state => state.libraries.current

const deleteCurrentFolderConfirmViewSelector = createSelector(
	[getCurrentLibraries],
	current => ({
		folderName: current.name,
	})
)

export default deleteCurrentFolderConfirmViewSelector
